import {Col, Modal, Row, Form, InputNumber, Button, Radio} from 'antd'
import {
  SBack,
  SSegmentedTabs,
  STableActions,
  SActionBtn, SFuncModal, SDrawerOrModal
} from 'shj-components'
import {useEffect} from "react";
import {isEmpty} from "lodash-es";

const PaySetModal = props => {

  const { open, onClose, prdBizTagList, onChangeTableData, record } = props
  const [ form ] = Form.useForm();
  const saleCreate = Form.useWatch('priceCreatedType', form);

  useEffect(() => {
    if (!isEmpty(record)) form.setFieldsValue(record)
    return () => {form.resetFields()}
  }, [record]);

  const onFinish = () => {
    form.validateFields().then((values: Record<string, any>) => {
      const value = values.priceCreatedType || record.priceCreatedType || prdBizTagList[0]?.value
      console.log(value, prdBizTagList)
      onChangeTableData?.({...values, priceCreatedTypeStr: prdBizTagList.find(item => item.value === value)?.label})
      onClose()
    });
  }

  return (
    <SDrawerOrModal
        mode={'modal'}
      open={open}
      onCancel={onClose}
      width={500}
      title="价格编辑"
      onOk={onFinish}
    >
      <Form
        style={{ padding: "10px 0" }}
        form={form}
        layout={'vertical'}
      >
        <Form.Item
          name="priceCreatedType"
          label="零售价生成"
          rules={[
            {
              required: true,
              message: '零售价生成',
            },
          ]}
          initialValue={prdBizTagList[0]?.value}
        >
          <Radio.Group
            options={prdBizTagList}
            onChange={() => form.setFieldValue('price', '')}
            style={{ padding: 0 }}
          />
        </Form.Item>
            <Form.Item
              name="price"
              label="零售价（元）"
              rules={[
                {
                  required: saleCreate === 'CUSTOM',
                  message: '请填写零售价',
                },
              ]}
              hidden={saleCreate !== 'CUSTOM'}
            >
              <InputNumber min={0.01} precision={2} style={{width: '100%'}} placeholder={'请填写零售价'}/>
            </Form.Item>
      </Form>
    </SDrawerOrModal>
  )
}

export default PaySetModal
